import { render } from "./MainLayout.vue?vue&type=template&id=c20e8642"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/classic/MainLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c20e8642"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c20e8642', __exports__)) {
    api.reload('c20e8642', __exports__)
  }
  
  module.hot.accept("./MainLayout.vue?vue&type=template&id=c20e8642", () => {
    api.rerender('c20e8642', render)
  })

}


export default __exports__